import * as R from 'ramda';
import { put, call, select, takeLatest } from 'redux-saga/effects';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// sagas
import { visitPageSaga as checkVisitPageSaga } from '../../sagas';
// centralized-dispatch
import * as A from './actions';
import * as H from './helpers';
import * as C from './constants';
import { makeSelectFilterSettings } from './selectors';
//////////////////////////////////////////////////

function* persistFilterSettingsSaga(filterSettings) {
  yield call(
    G.setItemToLocalStorage,
    C.CENTRALIZED_DISPATCH_FILTER_SETTINGS,
    filterSettings,
  );
  yield put(A.getFilterSettingsSuccess(filterSettings));
}

function* getFilterSettingsSaga() {
  const filterSettings = yield call(H.getFilterSettings);

  yield call(persistFilterSettingsSaga, filterSettings);

  return filterSettings;
}

const clearDefaultFilterSetting = (filterSettings, setting) => (
  R.propOr(false, GC.FIELD_DEFAULT, setting)
    ? R.map(R.assoc(GC.FIELD_DEFAULT, false), filterSettings)
    : filterSettings
);

function* saveFilterSettingsSaga({ payload }) {
  const filterSettings = yield select(makeSelectFilterSettings());
  const normalizedSetting = R.head(H.normalizeFilterSettings([payload]));
  const currentFilterSettings = clearDefaultFilterSetting(
    filterSettings,
    normalizedSetting,
  );
  const nextFilterSettings = R.append(normalizedSetting, currentFilterSettings);

  yield call(persistFilterSettingsSaga, nextFilterSettings);
}

function* updateFilterSettingsSaga({ payload }) {
  const filterSettings = yield select(makeSelectFilterSettings());
  const normalizedSetting = R.head(H.normalizeFilterSettings([payload]));
  const currentFilterSettings = clearDefaultFilterSetting(
    filterSettings,
    normalizedSetting,
  );
  const settingIndex = R.findIndex(
    R.propEq(R.prop(GC.FIELD_GUID, normalizedSetting), GC.FIELD_GUID),
    currentFilterSettings,
  );
  const nextFilterSettings = R.equals(settingIndex, -1)
    ? R.append(normalizedSetting, currentFilterSettings)
    : R.update(settingIndex, normalizedSetting, currentFilterSettings);

  yield call(persistFilterSettingsSaga, nextFilterSettings);
}

function* deleteFilterSettingsSaga({ payload }) {
  const filterSettings = yield select(makeSelectFilterSettings());
  const nextFilterSettings = R.reject(R.propEq(payload, GC.FIELD_GUID), filterSettings);

  yield call(persistFilterSettingsSaga, nextFilterSettings);
}

function* visitPageSaga({ payload }) {
  yield call(checkVisitPageSaga, payload, GC.CHECK_VISIT_CENTRALIZED_DISPATCH_PAGE);

  const filterSettings = yield call(getFilterSettingsSaga);

  const initialFilterSetting = H.getInitialFilterSetting(filterSettings);
  const filterValues = G.isNilOrEmpty(initialFilterSetting)
    ? H.getDefaultFilterValues()
    : H.getFilterValues(initialFilterSetting);
  const tripsOrderFields = H.getOrderFieldsForTripsFromFilters(filterValues);
  const tripsSearchCriteria = H.getSearchCriteriaForTripsFromFilters(filterValues);
  const driversRadiusRequestParams = H.getDriverRadiusRequestParams(filterValues);
  const driversSearchCriteria = H.getSearchCriteriaForDriversFromFilters(filterValues);

  yield put(A.setTripsOrderFields(tripsOrderFields));
  yield put(A.setTripsSearchCriteria(tripsSearchCriteria));
  yield put(A.setDriversSearchCriteria(driversSearchCriteria));
  yield put(A.setDriversRadiusRequestParams(driversRadiusRequestParams));
  yield put({
    payload: {
      centralizedDispatch: true,
      searchCriteria: tripsSearchCriteria,
      route: GC.ROUTE_PATH_DISPATCH_BOARD_TEL,
    },
    type: GC.VISIT_DISPATCH_BOARD_TEL_PAGE,
  });
  yield put({
    payload: {
      centralizedDispatch: true,
      searchCriteria: driversSearchCriteria,
      pathname: GC.ROUTE_PATH_AVAILABLE_DRIVER_LIST,
    },
    type: GC.VISIT_ROUTE_AVAILABLE_DRIVER_PAGE,
  });
}

export default function* centralizedDispatchWatcherSaga() {
  yield takeLatest(A.visitPage, visitPageSaga);
  yield takeLatest(A.getFilterSettingsRequest, getFilterSettingsSaga);
  yield takeLatest(A.saveFilterSettingsRequest, saveFilterSettingsSaga);
  yield takeLatest(A.deleteFilterSettingsRequest, deleteFilterSettingsSaga);
  yield takeLatest(A.updateFilterSettingsRequest, updateFilterSettingsSaga);
}
